import { render, staticRenderFns } from "./HouseBLMainTransportSea.vue?vue&type=template&id=71282a9f&scoped=true&"
import script from "./HouseBLMainTransportSea.vue?vue&type=script&lang=js&"
export * from "./HouseBLMainTransportSea.vue?vue&type=script&lang=js&"
import style0 from "./HouseBLMainTransportSea.vue?vue&type=style&index=0&id=71282a9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71282a9f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71282a9f')) {
      api.createRecord('71282a9f', component.options)
    } else {
      api.reload('71282a9f', component.options)
    }
    module.hot.accept("./HouseBLMainTransportSea.vue?vue&type=template&id=71282a9f&scoped=true&", function () {
      api.rerender('71282a9f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/pratica/houseBL/HouseBLMainTransportSea.vue"
export default component.exports